import React from 'react';
import { Form as FormikForm } from 'formik';
import { Box, Button } from '@material-ui/core';

interface FormWrapperProps {
    submitText?: React.ReactText;
    children: React.ReactNode[] | React.ReactNode;
    isSubmitting: boolean;
    isDialogView?: boolean;
    fullHeight?: boolean;
}

interface BoxCenteredProps {
    alignItems?: string;
    width?: string;
    height?: string;
}

const FormWrapper = ({ submitText, children, isSubmitting, isDialogView = false, fullHeight = false }: FormWrapperProps) => {
    let boxCenteredProps: BoxCenteredProps = isDialogView ? {
        alignItems: 'center',
        width: '100%',
    } : {};

    let height = {};
    if (fullHeight) {
        boxCenteredProps = {
            ...boxCenteredProps,
            height: '100%',
        };

        height = {
            height: '100%'
        };
    }

    return (
        <FormikForm style={{ ...height }} autoComplete="off">
            <Box display="flex" flexDirection="column" {...boxCenteredProps}>
                {children}
                {submitText && (
                <Box pt={1} display="flex" justifyContent="flex-end">
                    <Button
                        disabled={isSubmitting}
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        {submitText}
                    </Button>
                </Box>
                )}
            </Box>
        </FormikForm>
    );
};

FormWrapper.defaultProps = {
    disabled: false,
};


export default FormWrapper;
